import { render, staticRenderFns } from "./__account_form.vue?vue&type=template&id=cc84fb98&scoped=true&"
import script from "./__account_form.vue?vue&type=script&lang=js&"
export * from "./__account_form.vue?vue&type=script&lang=js&"
import style0 from "./__account_form.vue?vue&type=style&index=0&id=cc84fb98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc84fb98",
  null
  
)

export default component.exports